import { runtimeConfig } from "@src/runtime-config";
import { getAdminPanelApiUrl } from "@utils/url-utils";
import { useMemo } from "react";
import { StellarApiClient } from "@stellar/stellar-api-client";

interface SphereXGApi {
  /** Instance of the stellar api client */
  stellarApiClient: StellarApiClient;
}

/**
 * Hook that provides access to the Stellar API client.
 */
export function useStellarApiClient(): SphereXGApi {
  const stellarApiClient = useMemo(() => {
    const baseUrl = getAdminPanelApiUrl(
      runtimeConfig.urls.adminPanelApi,
      runtimeConfig.numberedEnv
    );
    return new StellarApiClient({ baseUrl });
  }, []);

  return { stellarApiClient };
}
